import { render, staticRenderFns } from "./ComponentDanMenu.vue?vue&type=template&id=a195f3a8&scoped=true"
import script from "./ComponentDanMenu.vue?vue&type=script&lang=js"
export * from "./ComponentDanMenu.vue?vue&type=script&lang=js"
import style0 from "./ComponentDanMenu.vue?vue&type=style&index=0&id=a195f3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a195f3a8",
  null
  
)

export default component.exports